import React from "react";
import { Icon } from "@material-ui/core";
import styles from "./update.module.css";

const AllRemovedBanner: React.FC = () => (
  <div className={styles.info}>
    <h1><Icon className={styles.infoIcon}>info</Icon> You&apos;re removed from all lists.</h1>
      You&apos;ve been removed from all lists, and no further action is required.
      If you removed yourself accidentally, you&apos;ll have to contact each property
      individually to request to be reinstated. Thanks!
  </div>
);

export default AllRemovedBanner;
